<template>
  <div>
    <div>
      <div class="container">
        <PageTitle icon="fa fa-cogs" main="Administração" sub="Usuários" 
          :help="true" 
          titleHelp="Ajuda - Administração do sistema" 
          content="Tela responsável por pesquisar usuários e definir permissões no Sistema, possibilitando pesquisa com filtros.
Para alteração/criação clique no submenu permissões, em seguida selecione o Grupo ou Usuário que as permissões serão alteradas, na parte direita da página selecione as permissõe que serão definidas.
          "/>
        <div class="card mt-2">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a class="nav-link active" id="users-tab" data-toggle="tab" href="#users" role="tab"
                aria-controls="users" aria-selected="true" >Usuarios</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" id="roles-tab" data-toggle="tab" href="#roles" role="tab"
                aria-controls="roles" aria-selected="false">Permissões</a>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane active" id="users" role="tabpanel" aria-labelledby="users-tab">
              <ListUsers />
            </div>
            <div class="tab-pane fade" id="roles" role="tabpanel" aria-labelledby="roles-tab">
              <Roles />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import PageTitle from "@/layouts/PageTitle";
import Roles from "../users/Roles";
import ListUsers from "../users/ListUsers";
export default {
  components: { PageTitle, Roles, ListUsers },
  name: "app",
};
</script>

<style>

</style>
